'use strict';

angular.module('impactx.attachments').controller('AttachmentsCtrl', AttachmentsCtrl);

AttachmentsCtrl.$inject = ['$scope', 'DownloadService', 'FileHelperService'];

function AttachmentsCtrl($scope, DownloadService, FileHelperService) {
    var ctrl = this;
    this.newText = {value: ""};
    this.handleFileSelect = function (evt) {
        setFormAsDirty();
        var file = evt.currentTarget.files[0];
        $(this).val("");
        ctrl.handleFile(evt, file);
    };
    this.handleFile = function (evt, file) {
        if ($scope.singleFile && $scope.attachments.newEntries && $scope.attachments.newEntries.length > 0) {
            ctrl.removeNewFile($scope.attachments.newEntries[0]);
        }
        setFormAsDirty();
        var newFile = {};
        newFile.fileName = file.name;
        var fileExtension = file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2);
        if (!FileHelperService.checkAllowedFileWithError(file.name)) {
            return;
        }
        var reader = new FileReader();
        reader.onload = function (evt) {
            $scope.$evalAsync(function ($scope) {
                newFile.file = evt.target.result;
                if ($scope.streamingUpload) {
                    newFile._rawFile = file;
                }
                if ($scope.hasVisibleForSupplierOption) {
                    newFile.visibilityClassifier1 = {value: ""};
                    newFile.isVisibleForSupplier = {value: false};
                }
                if ($scope.hasFixedOption) {
                    newFile.isFixed = {value: false};
                }
                if ($scope.hasTemplateOption) {
                    newFile.isTemplate = {value: false};
                }
                if (!$scope.attachments.newEntries) {
                    $scope.attachments.newEntries = [];
                }
                $scope.attachments.newEntries.push(newFile);
            });
        };
        reader.readAsDataURL(file);
    };

    this.addText = function () {
        var newEntry = {};
        newEntry.fileName = ctrl.newText.value;
        newEntry.textContent = ctrl.newText.value;
        newEntry.textContent = ctrl.newText.value;
        newEntry.isSmallText = true;

        if (!$scope.attachments.newEntries) {
            $scope.attachments.newEntries = [];
        }
        $scope.attachments.newEntries.push(newEntry);
        ctrl.newText.value = "";
    }

    this.fileSelect = function () {
        angular.element(document.querySelector('#fileInput' + $scope.dropzoneId)).click();
    };

    this.removeNewFile = function (file) {
        setFormAsDirty();
        $scope.attachments.newEntries.splice($scope.attachments.newEntries.indexOf(file), 1);
    };

    this.removeExistingFile = function (file) {
        $scope.attachments.existingEntries.splice($scope.attachments.existingEntries.indexOf(file), 1);
        if (!$scope.attachments.deletedEntries) {
            $scope.attachments.deletedEntries = [];
        }
        $scope.attachments.deletedEntries.push(file);
    };

    this.downloadMedia = function (mediaId) {
        DownloadService.openDownloadPost('/invoice/download/media', {paramName: "id", paramValue: parseInt(mediaId)});
    };

    function setFormAsDirty() {
        if ($scope.formController) {
            $scope.formController.$setDirty();
        }
    }

    this.checkFixedAndTemplate = function () {
        $scope.errorList.length = 0;
        if ($scope.attachments.existingEntries) {
            for (var i = 0; i < $scope.attachments.existingEntries.length; i++) {
                var existingFile = $scope.attachments.existingEntries[i];
                ctrl.handleErrorMessageForFile(existingFile);
            }
        }

        if ($scope.attachments.newEntries) {
            for (var j = 0; j < $scope.attachments.newEntries.length; j++) {
                var newFile = $scope.attachments.newEntries[j];
                ctrl.handleErrorMessageForFile(newFile);
            }
        }
    };

    this.handleErrorMessageForFile = function (fileToHandle) {
        if (fileToHandle.isFixed && fileToHandle.isFixed.value && fileToHandle.isTemplate && fileToHandle.isTemplate.value) {
            var errorMessage = $scope.notFixedAndTermsError.replace("^0", fileToHandle.fileName);
            fileToHandle.errorMessage = errorMessage;
            $scope.errorList.push(errorMessage);
        }
        else {
            fileToHandle.errorMessage = undefined;
        }
    };

    this.getFileClass = FileHelperService.getFileMdiClass;
}